import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=f17de4ea&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f17de4ea')) {
      api.createRecord('f17de4ea', component.options)
    } else {
      api.reload('f17de4ea', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=f17de4ea&", function () {
      api.rerender('f17de4ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dKmpTAbjqL3l/JS/comp/IncreaseNumber.vue"
export default component.exports